var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"text-align":"center","margin-top":"100px"}},[_vm._v("正在支付中，请稍后...")])])
}]

export { render, staticRenderFns }